const PUBLIC = '';

const PATHS = {
  advisoryBoardImages: `${PUBLIC}/images/Team_images/advisoryBoard/`,
  blogpostsImages: `${PUBLIC}/images/Blogposts_images/`,
  carouselImages: `${PUBLIC}/images/PicturesCarousel_images/`,
  disclaimerImages: `${PUBLIC}/images/Disclaimer_images/`,
  externalImages: `${PUBLIC}/images/Team_images/external_people/`,
  fallbackImage: `${PUBLIC}/images/NewsletterCarousel_images/Reboot_Fallback_Image.webp`,
  packagesImages: `${PUBLIC}/images/WPackages_images/`,
  partnersImages: `${PUBLIC}/team_images/partners/`,
  pdfs: `${PUBLIC}/pdfs/`,
  publicationsImages: `${PUBLIC}/publication_images/`,
  researchesImages: `${PUBLIC}/Research_images/`,
  researchersImages: `${PUBLIC}/team_images/researchers/`,
  teamWienImages: `${PUBLIC}/team_images/team_wien/`,
  teamSalfordImages: `${PUBLIC}/team_images/team_salford/`,
  teamBackgroundImages: `${PUBLIC}/team_images/background/`,
  homeImages: `${PUBLIC}/home_images/`,
  homeCarousel: `${PUBLIC}/home_images/carousel/`,
  homeHoverLinks: `${PUBLIC}/home_images/hover_links/`,
  researchPolicy: `${PUBLIC}/research_policy/`,
  homeModal: `${PUBLIC}/home_images/homemodal/`,
  logos: `${PUBLIC}/logos/`,
  homeCarouselSharedImages: `${PUBLIC}/carousel/`,
  newsCarouselImages: `${PUBLIC}/carousel/news/`,
  interviewCarouselImages: `${PUBLIC}/carousel/interviews/`,
  blogpostCarouselImages: `${PUBLIC}/carousel/blogposts/`,
  reportsCarouselImages: `${PUBLIC}/reports_carousel/`,
};

export default PATHS;
